import { useState } from 'react'

import TemplateListSidebar from './template-list-sidebar'
import NotifyAllDialog from './notify-all-dialog'
import CreateNewTemplate from './create-new-template'

const Menu = ({ template, processing, setProcessing }) => {
  const [notifyOpen, setNotifyOpen] = useState(false)
  const [createTemplateOpen, setCreateTemplateOpen] = useState(false)

  const notifyPasses = () => {
    if (!template?.archived) setNotifyOpen(true)
  }

  return (
    <>
      <TemplateListSidebar
        selectedTemplate={template}
        onNewTemplate={() => setCreateTemplateOpen(true)}
        onNotify={notifyPasses}
      />
      <NotifyAllDialog open={notifyOpen} setOpen={setNotifyOpen} template={template} processing={processing} setProcessing={setProcessing} />
      {createTemplateOpen && <CreateNewTemplate open onClose={() => setCreateTemplateOpen(false)} />}
    </>
  )
}

export default Menu
